import React, { useEffect, useState } from 'react';
import { sdk } from '@farcaster/miniapp-sdk';

const MiniAppWrapper = ({ children }) => {
  const [isReady, setIsReady] = useState(false);
  const [context, setContext] = useState(null);

  useEffect(() => {
    const initializeMiniApp = async () => {
      try {
        // Check if we're in a Mini App environment
        const isInMiniApp = await sdk.isInMiniApp();
        
        if (isInMiniApp) {
          console.log('🚀 Initializing Farcaster Mini App...');
          
          // Get context information
          const appContext = sdk.context;
          setContext(appContext);
          
          console.log('Mini App Context:', appContext);
          
          // Show ready state to hide splash screen
          await sdk.actions.ready();
          setIsReady(true);
          
          console.log('✅ Mini App ready!');
        } else {
          // Not in Mini App environment, just render normally
          setIsReady(true);
        }
      } catch (error) {
        console.error('❌ Error initializing Mini App:', error);
        // Fallback to normal rendering
        setIsReady(true);
      }
    };

    initializeMiniApp();
  }, []);

  // Show loading state while initializing
  if (!isReady) {
    return (
      <div className="min-h-screen bg-background flex items-center justify-center">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-500 mx-auto mb-4"></div>
          <p className="text-white">Loading Portfolio...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="miniapp-container">
      {children}
    </div>
  );
};

export default MiniAppWrapper; 